(function () {
  'use strict';
  if (window.HauteEditorial) return;
  window.HauteEditorial = { version: '1.0.0' };
  const storageKey = 'haute-saved-products-v1';
  let saved = [];
  try {
    const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(value)) saved = value.filter(id => typeof id === 'string');
  } catch (_) {}
  function syncSaved() {
    document.querySelectorAll('[data-haute-save]').forEach(button => {
      const active = saved.includes(button.dataset.hauteSave);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('title', active ? button.dataset.hauteRemoveLabel : button.dataset.hauteSaveLabel);
    });
  }
  function selectTab(tab, focus) {
    const section = tab.closest('.haute-featured');
    if (!section) return;
    section.querySelectorAll('[data-haute-tab]').forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    section.querySelectorAll('.haute-featured__panel').forEach(panel => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
    const collectionLink = section.querySelector('[data-haute-featured-link]');
    const collectionLabel = section.querySelector('[data-haute-featured-label]');
    if (collectionLink && tab.dataset.hauteTabUrl) collectionLink.href = tab.dataset.hauteTabUrl.trim();
    if (collectionLabel && tab.dataset.hauteTabLabel) collectionLabel.textContent = tab.dataset.hauteTabLabel;
    if (focus) tab.focus();
  }
  let dialog, returnFocus, previousOverflow = '';
  function closePreview() { if (dialog && dialog.open) dialog.close(); }
  function openPreview(button) {
    const source = document.getElementById(button.dataset.hautePreview);
    if (!source || !source.content) return;
    if (!window.HTMLDialogElement) {
      const link = source.content.querySelector('a[href]');
      if (link) window.location.assign(link.href);
      return;
    }
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'haute-scope haute-dialog';
      dialog.setAttribute('aria-labelledby', 'HauteQuickViewTitle');
      document.body.appendChild(dialog);
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closePreview();
      });
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'haute-dialog__close';
    close.setAttribute('aria-label', button.dataset.hauteCloseLabel);
    close.textContent = '×';
    close.addEventListener('click', closePreview);
    dialog.replaceChildren(close, source.content.cloneNode(true));
    const heading = dialog.querySelector('.haute-preview__title');
    if (heading) heading.id = 'HauteQuickViewTitle';
    returnFocus = button;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    close.focus();
    syncSaved();
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-haute-tab]');
    if (tab) { selectTab(tab, false); return; }
    const preview = event.target.closest('[data-haute-preview]');
    if (preview) { openPreview(preview); return; }
    const save = event.target.closest('[data-haute-save]');
    if (save) {
      const id = save.dataset.hauteSave;
      const index = saved.indexOf(id);
      if (index === -1) saved.push(id); else saved.splice(index, 1);
      try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {}
      syncSaved();
    }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-haute-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[data-haute-tab]'));
    const index = tabs.indexOf(tab);
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;
    event.preventDefault();
    selectTab(tabs[next], true);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-haute-sort]') && event.target.form) event.target.form.requestSubmit();
  });
  document.addEventListener('shopify:section:load', syncSaved);
  document.addEventListener('shopify:block:select', event => {
    const blockId = event.detail && event.detail.blockId;
    if (!blockId) return;
    const tab = Array.from(document.querySelectorAll('[data-haute-tab]')).find(item => item.dataset.hauteTab === blockId);
    if (tab) selectTab(tab, false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSaved); else syncSaved();
})();
